var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeakerNone = function SvgIconSpeakerNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.25 3a1 1 0 0 0-1.614-.79l-6.48 5.04H3A1.75 1.75 0 0 0 1.25 9v6A1.75 1.75 0 0 0 3 16.75h4.157l6.48 5.04A1 1 0 0 0 15.25 21zM8.5 8.74l4.75-3.695v13.91L8.5 15.261zm-2 .51H3.25v5.5H6.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpeakerNone;